export const useSigninBaseStore = defineStore('signinBase', () => {
  const { fetch } = useAdotFetch()

  // native 에서 받은 응답 값
  const receiveIdp = ref<RequestIdpDto>({
    socialType: '',
    transactionId: ''
  })
  // idsp 회사명
  const requestIdpType = ref<string>('')
  // 코드 값에 따라 API로 전달 할 request가 달라진다
  const validationCode = ref<string>('')
  const requestValidate = ref<RequestValidateDto>()
  // response에 이동될 페이지의 정보가 담겨져 있다
  const responseValidate = ref<ResponseValidateDetailDto>({
    validationCode: '',
    addSocialLogin: null,
    duplicatedSocialLogin: null,
    requiredCredential: null,
    requiredTermsAgreement: null,
    disabledUser: null
  })

  const pocId = ref<string>('')

  const setIdpType = (type: string) => {
    requestIdpType.value = type
  }

  const setIdpResult = (result: RequestIdpDto) => {
    receiveIdp.value = result
  }

  const setPocId = (id: string) => {
    pocId.value = id
  }

  const postSmsVerify = async (code: string, authToken: string): Promise<any> => {
    const param = {
      verifyCode: code
    }

    const response = await fetch('/user/public/v1/user-info/verify/mobile', {
      method: 'POST',
      headers: {
        'T-Authorization': authToken
      },
      credentials: 'include',
      body: param
    })

    if ('errorData' in response) {
      const { code, message } = response.errorData
      const transformed = {
        ...response,
        errorData: {
          ...response.errorData,
          message: getErrorMessage(code, message)
        }
      }
      return transformed
    }
    return response
  }

  const getSigninTerms = async (groupCodes = 'G_JOIN'): Promise<ResponseSigninTermsDto | null> => {
    const { data } = await fetch('/tna/public/v1/terms-groups', {
      query: {
        channelIds: 'OVTD',
        groupCodes
      },
      credentials: 'include'
    })

    return (data && data[0]) || null
  }

  const postSmsCredentialWithToken = async (param: CredentialMobileDto, token: string): FetchSmsResponse => {
    const response = await fetch<SmsSentResultDto>('/user/public/v1/user-info/issue/mobile', {
      method: 'POST',
      body: param,
      credentials: 'include',
      headers: {
        'T-Authorization': token
      }
    })

    return response
  }

  // TODO any typing
  const rePostSmsCredential = async (token: string, params: any): FetchSmsResponse => {
    const response = await fetch<SmsSentResultDto>('/user/public/v1/user-info/reissue/mobile', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'T-Authorization': token
      },
      body: params
    })

    return response
  }

  // 1) 본인인증 + 2) SNS 로 본인인증 + 3) 보호자 인증시 SMS 재전송
  const refreshSmsCredential = async (token: string, params: any): FetchSmsResponse => {
    const response = await fetch<SmsSentResultDto>('/user/public/v1/user-info/refresh/mobile', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'T-Authorization': token
      },
      body: params
    })

    return response
  }

  return {
    receiveIdp,
    requestValidate,
    responseValidate,
    validationCode,
    requestIdpType,
    pocId,
    postSmsVerify,
    getSigninTerms,
    setIdpType,
    postSmsCredentialWithToken,
    rePostSmsCredential,
    refreshSmsCredential,
    setIdpResult,
    setPocId
  }
})
